'use strict';

var _moment2 = require('moment');

var _moment3 = _interopRequireDefault(_moment2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initMomentDefinitions() {
    var locale = _moment3.default.locale();

    // Set locale to fr-FR temporarily to make sure
    // it is already loaded by moment
    _moment3.default.locale('fr-FR');
    _moment3.default.updateLocale(_moment3.default.locale(), {
        longDateFormat: {
            LT: 'HH[h]mm',
            LTS: 'HH[h]mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH[h]mm',
            LLLL: 'dddd D MMMM YYYY HH[h]mm'
        }
    });

    // Restore original locale
    _moment3.default.locale(locale);
}

initMomentDefinitions();

module.exports = {

    fixMomentDefinitions: function fixMomentDefinitions(locale) {
        var _moment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment3.default;

        locale = locale.replace(/_/, '-'); // moment receives locales such as "fr-FR"

        if (typeof __DEV__ !== 'undefined' && __DEV__ && locale === 'en-US') {
            // Moment.js has a smart logic for finiding the most suitable locale
            // according to requested locale. For example, when 'en-US' is requested,
            // it looks for the 'en-US' module, when it does not find it, moment falls
            // back to 'en'. This fallback mechanism uses require() to get the module -
            // if module is not found, it looks for the next one. In react-native development
            // mode (__DEV__) it shows the RedBox (red error all over the screen). Switching
            // to 'en' in order to avoid that. For more information see:
            // http://stackoverflow.com/questions/39245384/react-native-require-statement-exception-handling
            locale = 'en';
        }

        _moment.locale(locale);

        switch (locale) {
            case "fr-FR":
                _moment3.default.updateLocale(_moment.locale(), {
                    longDateFormat: {
                        LT: 'HH[h]mm',
                        LTS: 'HH[h]mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH[h]mm',
                        LLLL: 'dddd D MMMM YYYY HH[h]mm'
                    }
                });
                break;

            // See: https://github.com/moment/moment/issues/4006 
            case "tr-TR":
                _moment3.default.updateLocale(_moment.locale(), {
                    calendar: {
                        sameDay: '[bugün saat] LT',
                        nextDay: '[yarın saat] LT',
                        nextWeek: 'dddd [saat] LT',
                        lastDay: '[dün] LT',
                        lastWeek: '[geçen hafta] dddd [saat] LT',
                        sameElse: 'L'
                    }
                });
                break;

            // See: https://github.com/moment/moment/issues/4317
            case "ja-JP":
                _moment3.default.updateLocale(_moment.locale(), {
                    calendar: {
                        sameDay: '[今日] LT',
                        nextDay: '[明日] LT',
                        nextWeek: 'dddd LT',
                        lastDay: '[昨日] LT',
                        lastWeek: '[前週]dddd LT',
                        sameElse: 'L'
                    }
                });
                break;

            // English Israel acts like English GB
            case 'en-IL':
                _moment.locale('en-GB');
                break;

            default:
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-i18n-js/dist/Utils.js
// module id = 1450
// module chunks = 0